define('components/decorators/sorting',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator'
], function($, reload, decorator) {

    var FORM_ERROR_HEADER = 'form-errors';

    $.extend(companyInfo.decorators, {

        'sorting': function(e) {
            var component = $(this);
            var previous = '';
            var selectedOption = $(this.options[this.selectedIndex]);
            var generatedOption;

            var sortField = component.data('sortfield') || '';

            if (sortField === '') {
                generateOtherOption(component.val());
            } else {
                var otherOrder = sortField.split('-')[1] === 'asc' ? '-desc' : '-asc';
                var sortFieldOption = component.find("option[value=" + sortField + "]");
                var availableOption = sortFieldOption.length > 0 ? sortFieldOption : component.find("option[value=" + sortField.split('-')[0] + otherOrder + "]");

                selectedOption = availableOption;
                generateOtherOption(availableOption.val());
                component.select2('val', sortField);
                selectedOption = $(this.options[this.selectedIndex]);
            }

            $('.sorting .select2-choice').addClass('sorting-' + component.val().split('-')[1]);

            component.on('focus', function () {
                previous = component.val();
            }).change(function (e) {
                $('.sorting .select2-choice').removeClass('sorting-desc').removeClass('sorting-asc');
                $('.sorting .select2-choice').addClass('sorting-' + e.target.value.split('-')[1]);

                selectedOption = $(e.target.options[e.target.selectedIndex]);
                if (e.target.value.substring(0, e.target.value.indexOf('-')) !== previous.substring(0, previous.indexOf('-'))) {
                    if (generatedOption) {
                        generatedOption.remove();
                    }
                    component.find('.sorting-desc').removeClass('sorting-desc');
                    component.find('.sorting-asc').removeClass('sorting-asc');

                    generateOtherOption(e.target.value);
                } else {
                    selectedOption.insertBefore(component[0].options[0]);
                }
                previous = e.target.value;
            });

            function generateOtherOption(value) {
                var valueOrder = value.split('-')[1];
                if (value.substring(0, value.indexOf('-')) !== "relevance") {
                    var otherOption = selectedOption.clone();
                    var otherOrder = valueOrder === 'asc' ? 'desc' : 'asc';
                    otherOption.addClass('sorting-' + otherOrder);
                    otherOption.val(otherOption.val().replace(valueOrder, otherOrder));
                    component.prepend(otherOption);
                    generatedOption = otherOption;
                }
                selectedOption.addClass('sorting-' + valueOrder);
                selectedOption.insertBefore(component[0].options[0]);
            }
        },

    });

});

